import { render, staticRenderFns } from "./deposit-form.vue?vue&type=template&id=1836e233&scoped=true&"
import script from "./deposit-form.vue?vue&type=script&lang=js&"
export * from "./deposit-form.vue?vue&type=script&lang=js&"
import style0 from "./deposit-form.vue?vue&type=style&index=0&id=1836e233&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836e233",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1836e233')) {
      api.createRecord('1836e233', component.options)
    } else {
      api.reload('1836e233', component.options)
    }
    module.hot.accept("./deposit-form.vue?vue&type=template&id=1836e233&scoped=true&", function () {
      api.rerender('1836e233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apply/approval/@fragment/deposit-form.vue"
export default component.exports